import * as actionTypes from './actionTypes';
import axios from 'axios';

import { onBoardingStepCompletion } from '../../store/actions/index';

export const verifyStart = () => {
    return({
        type: actionTypes.VERIFY_START,
    });
}

export const smsStart = (phone) => {
    return({
        type: actionTypes.SMS_START,
        telephone: phone,
    });
}

export const smsSuccess = (token, userId) => {
    return({
        type: actionTypes.SMS_SUCCESS,
        token: token,
        userId: userId,
    });
}

export const verifySuccess = (uniqueId, code) => {
    return({
        type: actionTypes.VERIFY_SUCCESS,
        code: code,
        userId: uniqueId,
        verified: true,
    });
}

export const verifyError = (error) => {
    return({
        type: actionTypes.VERIFY_FAIL,
        error: error,
    });
}

export const smsError = (error) => {
    return({
        type: actionTypes.SMS_FAIL,
        error: error,
    });
}

export const checkVerifyState = () => {  
    return dispatch => {
       
    }
}

export const updateUserInfoStart = () => {
    return({
        type: actionTypes.UPDATE_USER_INFO_START,
    });
}

export const updateUserInfoSuccess = (data) => {
    return({
        type: actionTypes.UPDATE_USER_INFO_SUCCESS,
        payload: data,
    });
}

export const updateUserInfoError = (error) => {
    return({
        type: actionTypes.UPDATE_USER_INFO_ERROR,
        error: error
    });
}


export const onSendSMS = (country, phone, token, caseId, userType, verifyEmail = "", isVerifyEmailValid, isSignatureVerifyNeeded = undefined) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/sendSMS`;
    const data = {
        country: country,
        telephone: phone,
        refToken: token,
        userType: userType,
        caseId:caseId,
        verifyEmail, 
        isVerifyEmailValid,
        isSignatureVerifyNeeded
    };
    return (dispatch) => {
        dispatch(smsStart(phone));
        axios.post(url, {
            ...data
        })
        .then((response) => {
            console.log(response);
            if(response.data === 'error' || response.data === 'failed'){
                throw (`verify ${response.data}`);
            }
            //dispatch(verifySuccess(response.data.uniqueId, response.data.uniqueId));
            dispatch(smsSuccess(token, token));
        })
        .catch((error) => {
            console.log(error);
            dispatch(smsError(error));
        });
    };
}

export const onVerifyCode = (uniqueId, code, caseId, userType, telephone, handleComplete, isSignatureVerifyNeeded = undefined) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/verifySMS`;
    const verifyData = {
        refToken: uniqueId,
        verify_code: code,
        caseId: caseId,
        userType: userType,
        isSignatureVerifyNeeded
    };
    const userData = {
        telephone: telephone,
        refToken: uniqueId
    };
    return (dispatch) => {
        dispatch(verifyStart());
        axios.post(url, {
            ...verifyData
        })
        .then((response) => {
            console.log(response);
            if(response.data === 'error' || response.data === 'failed'){
                throw (`verify ${response.data}`);
            }

            if (response.data == 'error'){
                
            }
            else if (response.data == 'verified'){
                console.log('User has been verified');
                dispatch(verifySuccess(uniqueId, code));
                if(handleComplete !== null && handleComplete !== undefined){
                    handleComplete(isSignatureVerifyNeeded);
                }
            }
            else if (response.data == 'wrong_code'){
                
            }
        })
        .catch((error) => {
            console.log(error);
            dispatch(verifyError(error));
        });
    };
}

export const updateUserInfo = (userData, handleComplete) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/updateUserInfo`;
    return (dispatch) => {
        dispatch(updateUserInfoStart());
        axios.post(url, userData)
        .then((response) => {
            console.log(response);
            if(response.data === 'error' || response.data === 'failed'){
                throw (`verify ${response.data}`);
            }
            //dispatch(verifySuccess(response.data.uniqueId, response.data.uniqueId));
            dispatch(updateUserInfoSuccess(userData));
            if(handleComplete !== null && handleComplete !== undefined){
                handleComplete();
            }
        })
        .catch((error) => {
            console.log(error);
            dispatch(updateUserInfoError(error));
        });
    };
}

